import { type Theme } from "@mui/material";
import { type Components } from "@mui/material/styles";

import { type BadgeSize } from "../types";

declare module "@mui/material/Badge" {
  interface BadgeOwnProps {
    size?: BadgeSize;
  }
}

export const muiBadgeOverrides: Components<Theme> = {
  MuiBadge: {
    defaultProps: {
      size: "medium",
    },
    styleOverrides: {
      colorInfo: ({ theme }) => theme.palette.info?.main,

      badge: ({ theme }) => ({
        fontSize: theme.typography.body2.fontSize,
        variants: [
          {
            props: { size: "small", variant: "standard" },
            style: {
              minWidth: "1rem",
              height: "1rem",
              padding: `${theme.spacing(0)} ${theme.spacing(1)}`,
              fontSize: theme.typography.caption.fontSize,
            },
          },
          {
            props: { size: "large", variant: "standard" },
            style: {
              minWidth: "1.75rem",
              height: "1.75rem",
              padding: `${theme.spacing(0)} ${theme.spacing(3)}`,
              borderRadius: theme.borderRadius?.xLarge,
              fontSize: theme.typography.body2.fontSize,
            },
          },
        ],
      }),
    },
  },
};
